import { HiOutlineDocumentText, HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";
import { AnimatePresence, motion } from "framer-motion";
import {
  MdAirplanemodeActive,
  MdAssignment,
  MdAssignmentInd,
  MdBusiness,
  MdConnectingAirports,
  MdFeedback,
  MdLock,
  MdPeopleOutline,
  MdQuestionAnswer,
} from "react-icons/md";
import { logout } from "../../redux/userSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import RoutesDropdown from "components/RoutesDropdown/RoutesDropdown";
import { useState } from "react";
import {
  FaBuilding,
  FaCodeBranch,
  FaEnvelope,
  FaExchangeAlt,
  FaFileInvoiceDollar,
  FaHotel,
  FaInstagram,
  FaPlane,
  FaQuestionCircle,
  FaRegChartBar,
  FaUserPlus,
  FaUsers,
} from "react-icons/fa";
import { RiCustomerService2Line } from "react-icons/ri";
import katariatravels from "utils/images";
import { toast } from "react-toastify";
import userResources from "api/userResources";
import Logout from "components/Logout/Logout";
import { selectUserInfo, setUserInfo, login } from "../../redux/userSlice";
import Logo from "components/Home/Logo/Logo";
import { logo3 } from "utils/images";
import { logo2 } from "utils/images";
import { logo1 } from "utils/images";
import { IoSettingsSharp } from "react-icons/io5";
import {
  FiBarChart2,
  FiFileText,
  FiInbox,
  FiMapPin,
  FiPackage,
  FiUserCheck,
} from "react-icons/fi";
import config from "api/Confiq";
import { FcFeedback } from "react-icons/fc";
import { BsCreditCard2FrontFill } from "react-icons/bs";

const Sidebar = ({ open, onClose }) => {
  const [dropDown, setDropdown] = useState(false);
  const [invoiceDropDown, setInvocieDropdown] = useState(false);
  const [setupDropDown, setSetupDropdown] = useState(false);
  const userInfo = useSelector(selectUserInfo);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const currentRoute = params["*"]; // This will capture the current route path

  // Filter routes to only include those with a name key
  const filteredRoutes = routes?.filter((route) => route.show);

  // Updated function to check if CRM is active
  const isCRMActive = () => {
    return dropdownConfigs.some((config) => {
      // Check if the config has options
      if (config.options) {
        return config.options.some((option) => isActiveRoute(option.value));
      }

      // Check the route after cleaning '/admin/'
      if (config.route) {
        const cleanedRoute = config.route.replace("/admin/", "");
        return isActiveRoute(cleanedRoute);
      }
      // Fallback if no options or route
      return false;
    });
  };

  // Updated function to check if Invoice is active
  const isActiveRoute = (optionValue) => {
    // Check if the optionValue is an array and if currentRoute matches any value in it
    if (Array.isArray(optionValue)) {
      return optionValue.includes(currentRoute);
    }
    // Otherwise, check for a direct match
    return currentRoute === optionValue;
  };

  const isInvoiceActive = () => {
    return dropdownInvoiceConfigs.some((config) => {
      // Check if config has options and match them against the current route
      if (config.options) {
        return config.options.some((option) =>
          isInvoiceActiveRoute(option.value)
        );
      }

      // Check the config value after cleaning '/admin/'
      if (config.route) {
        const cleanedValue = config.route.replace("/admin/", "");
        return isInvoiceActiveRoute(cleanedValue);
      }

      // Fallback if no options or value
      return false;
    });
  };

  // Updated function to check if Invoice is active
  const isInvoiceActiveRoute = (optionValue) => {
    // Check if the optionValue is an array and if currentRoute matches any value in it
    if (Array.isArray(optionValue)) {
      return optionValue.includes(currentRoute);
    }
    // Otherwise, check for a direct match
    return currentRoute === optionValue;
  };

  const isSetupActive = () => {
    return dropdownSetupConfigs.some((config) =>
      // Check against options
      {
        if (config.route.option) {
          return config.options?.some((option) =>
            isSetupActiveRoute(option.value)
          );
        } else if (config.route) {
          const cleandedvalue = config.route.replace("/admin/", "");
          return isSetupActiveRoute(cleandedvalue);
        }
      }
    );
  };
  // Updated function to check if Invoice is active
  const isSetupActiveRoute = (optionValue) => {
    // Check if the optionValue is an array and if currentRoute matches any value in it
    if (Array.isArray(optionValue)) {
      return optionValue.includes(currentRoute);
    }
    // Otherwise, check for a direct match
    return currentRoute === optionValue;
  };
  // Dropdown configuration array
  const dropdownConfigs = [
    {
      name: "User Management",
      icon: (
        <FaUsers className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      options: [
        { value: "add-user", label: "Add User", route: "/auth/add-user" },
        { value: "user-list", label: "User List", route: "/admin/user-list" },
        {
          value: "employee-list",
          label: "Employee List",
          route: "/admin/employee-list",
        },
      ],
    },
    {
      value: [
        "create-enquiry",
        "create-enquiry/flight/round-trip",
        "create-enquiry/flight/oneway",
        "create-enquiry/flight/multi-city",
        "create-enquiry/hotel",
        "create-enquiry/other-service",
      ],
      icon: (
        <MdQuestionAnswer className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      name: "Create New Enquiry",
      route: "/admin/create-enquiry/flight/round-trip",
    },
    {
      name: "Flight Enquirys",
      icon: (
        <FaPlane className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      options: [
        {
          value: "enquiry-list",
          label: "All Enquiry List",
          route: "/admin/enquiry-list",
        },
        {
          value: "created-enquiry-list",
          label: "Created Enquiry List",
          route: "/admin/created-enquiry-list",
        },
        {
          value: "assigned-enquiry-list",
          label: "Assigned Enquiry List",
          route: "/admin/assigned-enquiry-list",
        },
        {
          value: "search-enquiry",
          label: "Search Enquiry",
          route: "/admin/search-enquiry",
        },
      ],
    },
    {
      name: "Hotel Enquirys",
      icon: (
        <FaHotel className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      options: [
        {
          value: "hotel-enquirys",
          label: "All Enquiry List",
          route: "/admin/hotel-enquirys",
        },
        {
          value: "hotel-created-enquirys",
          label: "Created Enquirys List",
          route: "/admin/hotel-created-enquirys",
        },
        {
          value: "hotel-assigned-enquirys",
          label: "Assigned Enquirys List",
          route: "/admin/hotel-assigned-enquirys",
        },
        {
          value: "search-hotel-enquirys",
          label: "Search Enquirys",
          route: "/admin/search-hotel-enquirys",
        },
      ],
    },
    {
      name: "Packages",
      icon: (
        <FiPackage className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      options: [
        {
          value: "package-enquirys",
          label: "All Enquiry List",
          route: "/admin/package-enquirys",
        },
        {
          value: "package-created-enquirys",
          label: "Created Enquirys List",
          route: "/admin/package-created-enquirys",
        },
        {
          value: "package-assigned-enquirys",
          label: "Assigned Enquirys List",
          route: "/admin/package-assigned-enquirys",
        },
        {
          value: "search-package-enquirys",
          label: "Search Enquirys",
          route: "/admin/search-package-enquirys",
        },
      ],
    },
    {
      name: "Other Enquirys",
      icon: (
        <FiInbox className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      options: [
        {
          value: "other-enquirys",
          label: "All Enquiry List",
          route: "/admin/other-enquirys",
        },
        {
          value: "other-created-enquirys",
          label: "Created Enquirys List",
          route: "/admin/other-created-enquirys",
        },
        {
          value: "other-assigned-enquirys",
          label: "Assigned Enquirys List",
          route: "/admin/other-assigned-enquirys",
        },
        {
          value: "search-other-enquirys",
          label: "Search Enquirys",
          route: "/admin/search-other-enquirys",
        },
      ],
    },
    {
      name: "Instagram Enquirys",
      icon: (
        <FaInstagram className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      route: "/admin/instagram-enquirys",
    },
    {
      name: "User Feedback",
      icon: (
        <MdFeedback className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      route: "/admin/user-feedback",
    },
    {
      name: "Credit Cards Information",
      icon: (
        <BsCreditCard2FrontFill className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      route: "/admin/credit-cards-information",
    },
    // {
    //   name: "Invoice Record",
    //   icon: (
    //     <FaCodeBranch className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
    //   ),
    //   options: [
    //     {
    //       value: "ktt-invoice",
    //       label: "Create google sheet",
    //       route: "/admin/ktt-invoice",
    //     },
    //     {
    //       value: "ktt-list",
    //       label: "KTT Inovice record",
    //       route: "/admin/ktt-invoice-record",
    //     },
    //   ],
    // },
  ];
  const dropdownInvoiceConfigs = [
    {
      name: "Create New Invoice",
      icon: (
        <FiFileText className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      route: "create-new-invoice/air-ticket",
    },
    {
      name: "Invoice List",
      icon: (
        <FiUserCheck className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      route: "/admin/total-invoice",
    },
    {
      name: "Search Invoices",
      icon: (
        <FiFileText className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      route: "/admin/search-invoices",
    },
    {
      name: "Tracking",
      icon: (
        <FiMapPin className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      options: [
        {
          value: "supplier-payment",
          label: "Supplier Payment",
          route: "/admin/supplier-payment",
        },
        {
          value: "pax-payment",
          label: "Pax Payment",
          route: "/admin/pax-payment",
        },
        // {
        //   value: "commission-receivables",
        //   label: "Commission Receivables",
        //   route: "/admin/commission-receivables",
        // },
        // {
        //   value: "refund-from-supplier",
        //   label: "Refund From Supplier",
        //   route: "/admin/refund-from-supplier",
        // },
      ],
    },
    {
      name: "Reports",
      icon: (
        <FiBarChart2 className="mr-4 h-6 w-6 text-gray-900 dark:text-[#bb8e25]" />
      ),
      options: [
        {
          value: "agency-sales",
          label: "Agency Sales Report",
          route: "/admin/agency-sales",
        },
        {
          value: "employee-sales",
          label: "Employee Sales",
          route: "/admin/employee-sales",
        },

        {
          value: "supplier-sales",
          label: "Supplier Sales",
          route: "/admin/supplier-sales",
        },
        {
          value: "airline-sales",
          label: "Airline Sales",
          route: "/admin/airline-sales",
        },
        {
          value: "destination-sales",
          label: "Destination Sales",
          route: "/admin/destination-sales",
        },
      ],
    },
  ];
  const dropdownSetupConfigs = [
    {
      name: "Branch",
      icon: (
        <FaBuilding className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/branch",
    },
    {
      name: "Air Lines",
      icon: (
        <FaPlane className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/air-lines",
    },
    {
      name: "Airport",
      icon: (
        <MdConnectingAirports className="mr-4 h-7 w-7 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/airport",
    },
    {
      name: "Department",
      icon: (
        <FaUsers className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/department",
    },
    {
      name: "Enquiry Status",
      icon: (
        <FaQuestionCircle className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/enquiry-status",
    },
    {
      name: "Enquiry Source",
      icon: (
        <FaRegChartBar className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/enquiry-source",
    },
    {
      name: "Transaction Type",
      icon: (
        <FaExchangeAlt className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/transaction-type",
    },
    {
      name: "Create New Supplier",
      icon: (
        <FaUserPlus className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/suppliers",
    },
    {
      name: "Create New Customer",
      icon: (
        <FaUserPlus className="mr-4 h-6 w-6 text-[#bb8e25] dark:text-gray-900" />
      ),
      route: "/admin/create-new-customer",
    },
  ];

  // Get role IDs from environment variables
  const ROLE_EMPLOYEE = Number(process.env.REACT_APP_ROLE_EMPLOYEE);
  const ROLE_USER = Number(process.env.REACT_APP_ROLE_USER);
  const ROLE_ADMIN = Number(process.env.REACT_APP_ROLE_ADMIN);
  const ROLE_SUPERADMIN = Number(process.env.REACT_APP_ROLE_SUPERADMIN);

  // Initialize an empty array for the filtered configs
  const filteredDropdownConfigs = [];

  // Use a loop with if-else to filter dropdownConfigs
  dropdownConfigs.forEach((config) => {
    // Exclude "User Management" and "Department" for ROLE_EMPLOYEE and ROLE_USER
    if (
      (userInfo.data.role_id === ROLE_EMPLOYEE ||
        userInfo.data.role_id === ROLE_USER) &&
      (config.name === "User Management" || config.name === "Department")
    ) {
      // Skip these configs for ROLE_EMPLOYEE and ROLE_USER
      return;
    }

    // For ROLE_ADMIN and ROLE_SUPERADMIN, filter out options based on value
    if (
      userInfo.data.role_id === ROLE_ADMIN ||
      userInfo.data.role_id === ROLE_SUPERADMIN
    ) {
      // Remove all options where option.value === option.value (effectively removes all options)
      const filteredOptions = config.options?.filter(
        (option) => option.value !== ""
        // (option) => option.value !== "assign-enquiry-list"
      );

      // If there are no options left after filtering, skip this config entirely
      if (filteredOptions?.length === 0) return;

      // Add the config with filtered options for ROLE_ADMIN and ROLE_SUPERADMIN
      filteredDropdownConfigs.push({ ...config, options: filteredOptions });
    } else {
      // For other roles, include the config as is
      filteredDropdownConfigs.push(config);
    }
  });

  // Initialize an empty array for the filtered configs
  const filteredDropdownInvoiceConfigs = [];

  // Use a loop with if-else to filter dropdownConfigs
  dropdownInvoiceConfigs.forEach((config) => {
    // For ROLE_ADMIN and ROLE_SUPERADMIN, filter out options based on value
    if (
      userInfo.data.role_id === ROLE_ADMIN ||
      userInfo.data.role_id === ROLE_SUPERADMIN
    ) {
      // Remove all options where option.value === option.value (effectively removes all options)
      const filteredOptions = config.options?.filter(
        (option) => option.value !== ""
        // (option) => option.value !== "assign-enquiry-list"
      );

      // If there are no options left after filtering, skip this config entirely
      if (filteredOptions?.length === 0) return;

      // Add the config with filtered options for ROLE_ADMIN and ROLE_SUPERADMIN
      filteredDropdownInvoiceConfigs.push({
        ...config,
        options: filteredOptions,
      });
    } else {
      // For other roles, include the config as is
      filteredDropdownInvoiceConfigs.push(config);
    }
  });

  // Initialize an empty array for the filtered configs
  const filteredDropdownSetupConfigs = [];

  // Use a loop with if-else to filter dropdownConfigs
  dropdownSetupConfigs.forEach((config) => {
    // For ROLE_ADMIN and ROLE_SUPERADMIN, filter out options based on value
    if (
      userInfo.data.role_id === ROLE_ADMIN ||
      userInfo.data.role_id === ROLE_SUPERADMIN
    ) {
      // Remove all options where option.value === option.value (effectively removes all options)
      const filteredOptions = config.options?.filter(
        (option) => option.value !== ""
        // (option) => option.value !== "assign-enquiry-list"
      );

      // If there are no options left after filtering, skip this config entirely
      if (filteredOptions?.length === 0) return;

      // Add the config with filtered options for ROLE_ADMIN and ROLE_SUPERADMIN
      filteredDropdownSetupConfigs.push({
        ...config,
        options: filteredOptions,
      });
    } else {
      // For other roles, include the config as is
      filteredDropdownSetupConfigs.push(config);
    }
  });

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[26px] mt-[10px] flex items-center`}>
        <div className="ml-1 mt-1 h-2.5 font-poppins text-[22px] font-bold uppercase text-navy-700 dark:text-[#dea113]">
          {/* Kataria <span className="font-medium">Travels</span> */}
          {/* <img src={katariatravels} alt="" className="w-24" /> */}
          <Logo
            logo1={logo1}
            logo2={logo2}
            logo3={logo3}
            width={{
              logo1: "w-16",
              logo2: "w-60",
              logo3: "w-40",
            }}
          />
        </div>
      </div>
      <div className="relative z-10 mb-7 mt-[100px] h-px overflow-scroll bg-gray-300 dark:bg-white/30" />
      <ul className="mb-auto max-h-[60vh] overflow-y-auto pt-1">
        <Links routes={filteredRoutes} />
        {/* CRM */}
        <li className="mx-8 my-4">
          <div
            className="flex cursor-pointer items-center"
            onClick={() => setDropdown(!dropDown)}
          >
            <RiCustomerService2Line className="mr-4 h-6 w-6 text-gray-900 dark:text-[#dea113]" />
            <p
              className={`font-semibold text-gray-500 hover:text-gray-900 dark:hover:text-[#dea113] ${
                isCRMActive() ? "text-gray-900 dark:text-[#dea113]" : ""
              }`}
            >
              CRM
            </p>
          </div>

          {/* Render dropdowns dynamically */}
          {dropDown && (
            <ul>
              {filteredDropdownConfigs.map((config, index) => (
                <li key={index} className="my-4 flex cursor-pointer">
                  {config.icon}
                  {/* Wrap inner content in a <div> or other element */}
                  <div>
                    {config.route ? (
                      <div
                        onClick={() => navigate(config.route)}
                        className={`font-semibold hover:text-black dark:hover:text-[#dea113] ${
                          isActiveRoute(config.route.replace("/admin/", ""))
                            ? "text-gray-900 dark:text-[#d6ad4e]"
                            : "text-gray-500"
                        }`}
                      >
                        {config.name}
                      </div>
                    ) : (
                      <RoutesDropdown
                        options={config.options}
                        name={config.name}
                      />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </li>
        {/* <Links routes={filteredRoutes} /> */}
        {/* Invoice */}
        {/* {userInfo.data.role_id === ROLE_ADMIN ||
          (userInfo.data.role_id === ROLE_SUPERADMIN && ( */}
            <li className="mx-8 my-4">
              <div
                className="flex cursor-pointer items-center"
                onClick={() => setInvocieDropdown(!invoiceDropDown)}
              >
                <FaFileInvoiceDollar className="mr-4 h-6 w-6 text-gray-900 dark:text-[#dea113]" />
                <p
                  className={`font-semibold text-gray-500 hover:text-gray-900 dark:hover:text-[#dea113] ${
                    isInvoiceActive() ? "text-gray-900 dark:text-[#dea113]" : ""
                  }`}
                >
                  Invoice
                </p>
              </div>

              {invoiceDropDown && (
                <ul>
                  {filteredDropdownInvoiceConfigs.map((config, index) => (
                    <li key={index} className="my-4 flex cursor-pointer">
                      {config.icon}
                      <div>
                        {config.route ? (
                          <div
                            onClick={() => navigate(config.route)}
                            className={`font-semibold hover:text-black dark:hover:text-[#dea113] ${
                              isInvoiceActiveRoute(
                                config.route.replace("/admin/", "")
                              )
                                ? "text-gray-900 dark:text-[#d6ad4e]"
                                : "text-gray-500"
                            }`}
                          >
                            {config.name}
                          </div>
                        ) : (
                          <RoutesDropdown
                            options={config.options}
                            name={config.name}
                          />
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          {/* ))} */}
      </ul>
      <div className="relative mx-8 my-4">
        <div
          className="flex cursor-pointer items-center"
          onClick={() => setSetupDropdown(!setupDropDown)}
        >
          <div
            className={`mr-4  transform text-gray-900 transition-transform duration-300 ease-in-out dark:text-[#dea113] ${
              setupDropDown ? "rotate-180" : "rotate-0"
            }`}
          >
            <IoSettingsSharp className="h-6 w-6" />
          </div>
          <p
            className={`font-semibold text-gray-500 hover:text-gray-900 dark:hover:text-[#dea113] ${
              isSetupActive() ? "text-gray-900 dark:text-[#dea113]" : ""
            }`}
          >
            Setup
          </p>
        </div>

        {setupDropDown && (
          <AnimatePresence>
            <ul className="absolute bottom-10 z-50">
              {filteredDropdownSetupConfigs.map((config, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 1, y: 20 }}
                  transition={{
                    ease: "easeInOut",
                    delay: (filteredDropdownSetupConfigs.length - index) * 0.2, // Stagger from last to first
                    duration: 0.3, // Adjust the duration for smoother animation
                  }}
                  className="my-1 flex w-fit cursor-pointer rounded-md bg-gray-900 p-2 dark:bg-white"
                >
                  {config.icon}
                  <div>
                    {config.route ? (
                      <div
                        onClick={() => {
                          navigate(config.route);
                          setSetupDropdown(!setupDropDown);
                        }}
                        className={`font-semibold hover:text-[#dea113] dark:hover:text-black ${
                          isSetupActiveRoute(
                            config.route.replace("/admin/", "")
                          )
                            ? "text-white dark:text-gray-900"
                            : "text-gray-500"
                        }`}
                      >
                        {config.name}
                      </div>
                    ) : (
                      <RoutesDropdown
                        options={config.options}
                        name={config.name}
                      />
                    )}
                  </div>
                </motion.li>
              ))}
            </ul>
          </AnimatePresence>
        )}
      </div>
      <Logout />

      {/* <div className="flex justify-center"><SidebarCard /></div> */}
    </div>
  );
};

export default Sidebar;
